import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-contact',
  imports: [FormsModule],
  templateUrl: './contact.html',
  styleUrl: './contact.css',
})
export class Contact {
  readonly name = signal('');
  readonly email = signal('');
  readonly message = signal('');

  submit(event: Event): void {
    event.preventDefault();

    const subject = encodeURIComponent(`Message from ${this.name()}`);
    const body = encodeURIComponent(`${this.message()}\n\nFrom: ${this.name()} (${this.email()})`);

    window.location.href = `mailto:hr@techcolleagues.com?subject=${subject}&body=${body}`;
  }
}
